import {
  TeacherIEType,
  TeacherHireType,
  TeacherLEType,
  TeacherNPType,
  TeacherSEType,
} from 'types';
import {
  GetTeacherTypesQuery,
  IndividualEntrepreneurType,
  LegalEntityType,
  NaturalPersonType,
  SelfEmployedType,
} from 'core';

export type TeacherPossibleType =
  | {
      [TeacherHireType.Ie]: TeacherIEType;
    }
  | {
      [TeacherHireType.Le]: TeacherLEType;
    }
  | {
      [TeacherHireType.Np]: TeacherNPType;
    }
  | {
      [TeacherHireType.Se]: TeacherSEType;
    };

export const transformToHireTypes = (
  data: GetTeacherTypesQuery | undefined,
): TeacherPossibleType[] => {
  const teacherTypes = data?.teacher?.employmentTypes;

  if (teacherTypes) {
    const result = teacherTypes.reduce(
      (resultTeacherTypes: TeacherPossibleType[], currentItem) => {
        if (currentItem === null) {
          return resultTeacherTypes;
        }

        const currentItemTypename = currentItem.__typename;
        switch (currentItemTypename) {
          case 'IndividualEntrepreneurType': {
            const type = currentItem as IndividualEntrepreneurType;
            const teacherType: TeacherIEType = {
              id: type.id,
              registrationAddress: type.registrationAddress,
              accountNumber: type.accountNumber,
              bankTitle: type.bankTitle,
              bic: type.bic,
              inn: type.inn,
            };

            return [
              ...resultTeacherTypes,
              {
                [TeacherHireType.Ie]: teacherType,
              },
            ];
          }
          case 'LegalEntityType': {
            const type = currentItem as LegalEntityType;
            const teacherType: TeacherLEType = {
              id: type.id,
              registrationAddress: type.registrationAddress,
              accountNumber: type.accountNumber,
              bankTitle: type.bankTitle,
              bic: type.bic,
              title: type.tittle,
              inn: type.inn,
            };
            return [
              ...resultTeacherTypes,
              {
                [TeacherHireType.Le]: teacherType,
              },
            ];
          }
          case 'NaturalPersonType': {
            const type = currentItem as NaturalPersonType;
            const teacherType: TeacherNPType = {
              id: type.id,
              registrationAddress: type.registrationAddress,
              accountNumber: type.accountNumber,
              bankTitle: type.bankTitle,
              bic: type.bic,
              nationality: {
                id: type.nationality.id,
                title: type.nationality.title,
              },
              passportNumber: type.passportNumber,
            };

            return [
              ...resultTeacherTypes,
              {
                [TeacherHireType.Np]: teacherType,
              },
            ];
          }
          case 'SelfEmployedType': {
            const type = currentItem as SelfEmployedType;
            const teacherType: TeacherSEType = {
              id: type.id,
              registrationAddress: type.registrationAddress,
              accountNumber: type.accountNumber,
              bankTitle: type.bankTitle,
              bic: type.bic,
              nationality: {
                id: type.nationality.id,
                title: type.nationality.title,
              },
              passportNumber: type.passportNumber,
              inn: type.inn,
            };

            return [
              ...resultTeacherTypes,
              {
                [TeacherHireType.Se]: teacherType,
              },
            ];
          }
          default:
            return resultTeacherTypes;
        }
      },
      [],
    );

    return result;
  }

  return [];
};
